<template> 
    <v-navigation-drawer
      :mini-variant.sync="drawer"
      :width="280"
      app
      clipped
      color="navigationBackground"
      permanent
    >
      <v-list 
        flat
        color="navigationListBackground"         
      >
        <template v-for="(item, i) in items">
          <!-- :prepend-icon="item.icon" -->
          <!-- REGULAR NAVIGATION ITEMS v-if -->
          <v-list-group
            v-if="item.group === 'menu'"
            :key="`item.title-${i}`"            
            no-action
            @click="trackMixpanel(item.mixpanel)"
            class="navigationLink"
          >
            <template slot="activator">
              <v-list-item-icon>
                <!-- color="#adadad" -->
                <v-icon >{{ item.icon }}</v-icon>
              </v-list-item-icon>            
              <v-list-item-content>
                <v-list-item-title 
                  v-bind:alvqa="item.alvqa"
                >{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
            
            <!-- Sub-items (internal routes and external links) -->
            <template v-for="(subItem, i) in item.items">
              <!-- Internal route -->
              <v-list-item
                v-if="!subItem.external"
                :key="`subItem.title-${i}`"
                :to="subItem.to"
                @click="trackMixpanel(subItem.mixpanel)"
                class="navigationLink"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-bind:alvqa="subItem.alvqa"
                  >                    
                    <v-icon color="navigationSubitemIcon">arrow_right</v-icon>
                    {{ subItem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- External link -->
              <v-list-item
                v-else
                :key="`subItem.title-ext-${i}`"
                :href="subItem.to"
                target="_blank"
                @click="trackMixpanel(subItem.mixpanel)"
                class="navigationLink"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-bind:alvqa="subItem.alvqa"
                  >                    
                    <v-icon color="navigationSubitemIcon">arrow_right</v-icon>
                    {{ subItem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>

          <!-- Fixed Navigation Targets outside ALV, e.g. https://www.alv-help.com -->
          <v-list-item
            v-if="item.group === 'outside'"
            :key="`item.title-${i}`"
            target="_blank"
            :href="item.to"
            @click="trackMixpanel(item.mixpanel)"
            class="navigationLink"
            >            
            <v-list-item-icon>
              <!-- color="#adadad" -->
              <v-icon >{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-bind:alvqa="item.alvqa"
              >{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item> 

          <!-- Fixed Navigation Targets inside ALV -->
          <v-list-item
            v-if="item.group === 'inside'"
            :key="`item.title-${i}`"
            :to="item.to"
            @click="trackMixpanel(item.mixpanel)"
            class="navigationLink"
            >            
            <v-list-item-icon>
              <!-- color="#adadad" -->
              <v-icon >{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-bind:alvqa="item.alvqa"
              >{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
import BaseIcon from './_buttons/BaseIcon'
import { buildNavigationItems } from './navigationItems'

export default {
  name: 'Navigation',
  components: {
    BaseIcon
  },
  data() {
    return {
      mini: true
    }
  },
  computed: {
    drawer: {
      get() { return this.$store.getters.getDrawer },
      set(value) { this.$store.commit('setDrawer', value)}
    },
    /** Returns the options for the menu in the selected language.
     * The property returns an Array with objects with the needed properties.
     * 
     * @return {object[]} Returns an object with some properties. */
    items() {
      return buildNavigationItems(this.$t.bind(this))
    }
  },
  methods: {
    trackMixpanel(item) {
        if (item != undefined) {
            mixpanel.track(item, {
                'locale': this.$i18n.locale,
                'userId': this.$store.getters.getUser.id,

            })
        }
    }
  }
}
</script>

<style scope>
.v-list .v-list-item--active {
    color: var(--v-navigationItemsIconsActive-base) !important;
}

 .v-list-group--active {
  background-color: var(--v-navigationBackgroundActiveGroup-base);
}
/* v-list-group__header__prepend-icon */
.v-list-item:hover:before {
  display: block !important;
  opacity: .12 !important;
  background-color: var(--v-navigationHoverItem-base);
}

.v-list-item__title {
  font-size: 1rem !important;
}
</style>
